export default {
  // E01r24RwdJ
  a: "E",
  b: "0",
  c: "1",
  d: "r",
  e: "2",
  f: "4",
  g: "R",
  h: "w",
  i: "d",
  j: "J",
  // YVgDe5H3aO
  k: "Y",
  l: "V",
  m: "g",
  n: "D",
  o: "e",
  p: "5",
  q: "H",
  r: "3",
  s: "a",
  t: "O",
  // CKIhAuPfUv
  u: "C",
  v: "K",
  w: "I",
  x: "h",
  y: "A",
  z: "u",
  A: "P",
  B: "f",
  C: "U",
  D: "v",
  // p9Z6XNtxqW
  E: "p",
  F: "9",
  G: "Z",
  H: "6",
  I: "X",
  J: "N",
  K: "t",
  L: "x",
  M: "q",
  N: "W",
  // 7cjnlsBiGo
  O: "7",
  P: "c",
  Q: "j",
  R: "n",
  S: "l",
  T: "s",
  U: "B",
  V: "i",
  W: "G",
  X: "o",
  // QkFLbzTSy8Mm
  Y: "Q",
  Z: "k",
  0: "F",
  1: "L",
  2: "b",
  3: "z",
  4: "T",
  5: "S",
  6: "y",
  7: "8",
  8: "M",
  9: "m",
};